import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500;700;900&family=Noto+Serif+TC:wght@500;700&family=Plus+Jakarta+Sans:wght@400;500;700;800&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&display=swap');

  :root {
    /* Brand palette */
    --color-bg: #fcf8f9;
    --color-bg-soft: #fbeef3;
    --color-bg-card: #ffffff;
    --color-ink: #1b0d12;
    --color-ink-soft: #4b2b37;
    --color-muted: #6b3547;
    --color-primary: #d5728a;
    --color-primary-soft: #f5c6d3;
    --color-primary-deep: #b85578;
    --color-line: #f1dbe2;
    --color-line-strong: #e7cfd7;

    /* Radius (bento) */
    --radius-xs: 10px;
    --radius-sm: 14px;
    --radius-md: 20px;
    --radius-lg: 28px;
    --radius-xl: 36px;
    --radius-pill: 999px;

    /* Container widths */
    --container-tight: 960px;
    --container: 1200px;
    --container-wide: 1320px;
    --container-xl: 1480px;

    /* Shadow */
    --shadow-card: 0 12px 40px rgba(27, 13, 18, 0.06);
    --shadow-card-hover: 0 24px 56px rgba(213, 114, 138, 0.15);
    --shadow-heavy: 0 30px 80px rgba(27, 13, 18, 0.18);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: ${(props) => props.theme.fonts.primary};
    background-color: var(--color-bg);
    color: var(--color-ink);
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
  }

  /* Un-cap the layout container so full-bleed sections work on ultrawide */
  .layout-container {
    max-width: 100%;
    margin: 0 auto;
    width: 100%;
  }

  .layout-content-container {
    max-width: var(--container);
    margin: 0 auto;
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${(props) => props.theme.fonts.heading};
    line-height: 1.2;
    text-wrap: balance;
  }

  /* Avoid a lone character / punctuation on the last line (CJK) */
  p, li, label, blockquote, figcaption {
    text-wrap: pretty;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`

export default GlobalStyles
